<template>
  <div>
    <v-card>
      <v-card-title
        :style="{ 'background-color': getThemeColor, color: 'white' }"
        class="headline lighten-2"
        >Select Student and View Statement</v-card-title
      >
      <DatePickerWithMenu
        class="mx-4"
        @date-selected="getStatementDateSelected"
      ></DatePickerWithMenu>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" dark @click="closeDialog()">Cancel</v-btn>
        <v-btn color="primary" dark @click="viewStudentStatement()"
          >View Now</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import DatePickerWithMenu from "@/components/myLibrary/DatePickerWithMenu.vue";
export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  props: {
    selectedStudentSid: {
      default: null,
    },
  },
  components: { DatePickerWithMenu },
  data: () => ({
    statementDateSelected: new Date().toISOString().substring(0, 10),
  }),
  methods: {
    getStatementDateSelected(newDate) {
      this.statementDateSelected = newDate;
    },
    viewStudentStatement() {
      if (!this.selectedStudentSid) {
        alert("You Must Select At least One(1) Student!");
        event.preventDefault();
        return;
      }

      this.$router.push({
        name: "students-statements",
        params: {
          selectedStudents: [this.selectedStudentSid],
          statementsDate: this.statementDateSelected,
        },
      });
    },
    closeDialog() {
      //nothing
    },
  },
};
</script>
